angular.module('wbDashboard')
.controller('MilestoneModCreateController', ['$scope', '$q', '$location', '$filter', '$uibModal', '$timeout', 'User', 'PlanService', 'Milestone', 'RiskScore', 'Misc', 'Message', 'Track',
function ($scope, $q, $location, $filter, $uibModal, $timeout, User, PlanService, Milestone, RiskScore, Misc, Message, Track) {
    $scope.mod.action = "create";
    //default pages
    $scope.mod.defaultPages = function() {
        //this can probably be removed as it's likely no longer needed
        //will be replaced moment milestone type controller is loaded
        // angular.copy(['select', 'amount', 'portfolio-type', 'allocation-start', 'initial-deposit', 'auto-deposit'], $scope.pages);
    };
    $scope.mod.defaultPages();

    Milestone.clearMS();

    Milestone.getAvailable().then(function(data) {
        $scope.milestoneDefaults = data;
        if (Object.keys($scope.milestoneDefaults).length) {

            if ($scope.milestoneDefaults[$scope.$stateParams.msType]) {
                $scope.pageData.typeClicked = $scope.$stateParams.msType;
                $scope.setMilestoneTypeAndContinue($scope.$stateParams.msType, $scope.$stateParams.redirectSection);
            }

            Track.send("View Choose New Milestone", "milestone", {});
        }
    });
    $scope.$watch(User.getOverview, function(overview) {
        if (overview) {
            Milestone.setBirthDate(overview.user.birth_date);

            angular.forEach(overview.account_overview, function(account) {
                if (account.is_pending) {
                    if (account.is_ira) {
                        //IRA
                        Message.set({
                            key: 'pending_account_milestone',
                            type: 'warning',
                            text: 'Your pending investment account must be funded before creating new milestones.'
                        });
                    } else {
                        //PIA
                        Message.set({
                            key: 'pending_account_milestone',
                            type: 'warning',
                            text: 'Your pending investment account must be funded before creating new milestones.'
                        });
                    }
                }
            });
        }
    });

    // User.retrieveBankAccounts();
    // $scope.$watch(User.getBankAccounts, function(bankAccounts) {
    //     //display "from" bank for initial deposit
    //     if (bankAccounts) {
    //         $scope.bank = bankAccounts.active;
    //     }
    // });

    // $scope.$watch(function() { return PlanService.user.getAutos(); }, function(autos) {
    //     if (autos) {
    //         $scope.setFrequency();
    //     }
    // });
    // $scope.setFrequency= function() {
    //     var autos = PlanService.user.getAutos();
    //     if (autos) {
    //         $scope.milestone.auto_deposit.frequency = autos.frequency.toLowerCase();
    //     }
    // };


    $scope.mod.submitMilestone = function() {
        var data= Milestone.prepareSubmitData($scope.milestone);

        $scope.pageData.sending = true;
        $scope.pageData.creating = true;

        Track.send("Click Add to Plan", "milestone", {'milestone': $scope.milestone.type});

        Milestone.create(data).then(function() {
            Track.send("New Milestone Created", "milestone", {
                "milestone": $scope.milestone.type,
                // "auto-deposit": !!$scope.milestone.auto_deposit.amount,
                "target" : $scope.milestone.target_amount,
                // "initial_deposit" : $scope.milestone.initial_deposit,
                // "auto-deposit_amount" : $scope.milestone.auto_deposit.amount,
                // "auto-deposit_frequency" : $scope.milestone.auto_deposit.frequency
            });

            //need to get new ms of unknown id
            User.retrieveOverview(true);
            User.retrieveAllMilestones(true);
            User.retrieveActivityPending(true);

            PlanService.user.retrieveAutos();

            //clear milestone list in portfolioPositions
            PlanService.user.clearPortfolioExtra();
            if ($scope.milestone.type === 'retirement') {
                //in case there's a add-retirement rollover step
                PlanService.user.clearRollovers();
            }

            $scope.$state.go("base.receipt", { receipt: {
                "action": "CREATE_MILESTONE",
                "type": $scope.milestone.type,
                "milestone_name": $scope.milestone.name,
                "amount": $scope.milestone.initial_deposit,
                "auto_amount": $scope.milestone.auto_deposit.amount,
                "redirectSection": $scope.$stateParams.redirectSection
            }});

        }).catch(function() {
            $scope.pageData.sending = false;
            $scope.pageData.creating = false;
            Message.set({
                text:"Something went wrong, please try again. If you continue to have problems, please email support@axosinvest.com.",
                type: "danger"
            });
        });

    };

    /**
     * Set defaults anytime milestone is selected
     */
    $scope.$watch('milestone.type', function(type) {
        if (type && !$scope.milestone.extra.defaultsSet && $scope.milestoneDefaults) {
            //instead of overwriting existing values with defaults, just clear and start over
            Milestone.clearMS();
            $scope.milestone.type = type;
            $scope.milestone.type_real = type;
            Milestone.setDefaults();
            // $scope.setFrequency();

            Milestone.getGlideRecommend($scope.milestone);
        }
    });




    /**
     * Reset all initial milestone values
     * @param type
     */
    $scope.setPageDefaults = function() {
        Milestone.setSectionDefaults($scope.$stateParams.page);
    };
    $scope.setMilestoneTypeAndContinue = function(type, replace) {
        if (!$scope.milestoneDefaults || !$scope.milestoneDefaults[type]) {
            return;
        }
        if ($scope.milestone.type !== type) {
            $scope.milestone.type = type;
            $scope.milestone.extra.defaultsSet = false;
        }
        Track.send("Choose New Milestone", "milestone", {'milestone': $scope.milestone.type});
        $scope.goNextPage(replace);
    };

    /**
     ******************************************
     * Page Related
     ******************************************
     */
    $scope.mod.initPage.preCheck = function(page) {
        if (!$scope.milestone.type && page !== "select") {
            //can only select type on select page, so have to go there
            $scope.goToPage("select", true);
            return false;
        }
        return true;
    };
    $scope.mod.initPage.create = function(page) {
        switch (page) {
            case 'select':
                if ($scope.milestoneDefaults && Object.keys($scope.milestoneDefaults).length) {
                    //on initial load, this is skipped since milestoneDefaults aren't loaded yet
                    Track.send("View Choose New Milestone", "milestone", {});
                }
                break;
            case 'amount':
                Track.send("New Amount", "milestone", {'milestone': $scope.milestone.type});
                break;
            case 'allocation-start':
                Track.send("New Allocation", "milestone", {'milestone': $scope.milestone.type});
                break;
            case 'initial-deposit':
                Track.send("New Initial Deposit", "milestone", {'milestone': $scope.milestone.type});
                break;
            case 'auto-deposit':
                Track.send("New Auto-Deposit", "milestone", {'milestone': $scope.milestone.type});
                break;
        }
    };

    $timeout(function() {
        //need time for sub-milestone controller to load
        $scope.mod.initPage($scope.$stateParams.page);
    });

}]);
